import { useEffect, useMemo } from 'react';
import Link from 'next/link';
import cn from 'classnames';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import { useLocale } from '@/context/LocaleContext';

gsap.registerPlugin(ScrollTrigger);

const BotonPrimario = ({
  type = 'link',
  label,
  bgColor,
  textColor,
  route = '/',
  onClick,
  buttonType,
  disabled,
  className,
  ariaLabel
}) => {
  const locale = useLocale();
  const classes = useMemo(() => ({ 'opacity-50 pointer-events-none': disabled }), [disabled]);

  useEffect(() => {
    const botonesPrimarios = gsap.utils.toArray('.btn-primario-js');

    botonesPrimarios.forEach((elem) => {
      gsap.fromTo(
        elem,
        {
          autoAlpha: 0,
          y: 10
        },
        {
          scrollTrigger: {
            trigger: elem,
            start: 'top bottom'
            // markers: true
          },
          autoAlpha: 1,
          y: 0,
          delay: 0.5
        }
      );
    });
  }, []);

  const inner = useMemo(() => {
    return (
      <>
        <div
          className={cn(
            bgColor,
            'inline-block w-full relative py-16 sm:py-10 px-26 rounded-full | btn-primario-js'
          )}
        >
          <div
            className={cn(
              textColor,
              'p1 !text-12 sm:!text-16 for-button !tracking-[1%] relative z-3 uppercase text-center'
            )}
          >
            <span className="span-basic block">{label}</span>
            <span className="span-hover block absolute top-0 left-1/2 -translate-x-1/2 whitespace-nowrap">
              {label}
            </span>
          </div>
        </div>
      </>
    );
  }, [label, bgColor, textColor]);

  if (type === 'link')
    return (
      <Link href={route} locale={locale} className={cn(classes, className)} aria-label={ariaLabel}>
        {inner}
      </Link>
    );

  return (
    <button
      onClick={onClick}
      className={cn(classes, className, `w-full`)}
      type={buttonType || 'button'}
      aria-label={ariaLabel}
    >
      {inner}
    </button>
  );
};
export default BotonPrimario;
